import React from 'react'
import { PageContent, ContentMenu, ContentMenuTab, Text, Video } from 'components/library'

import tab01img01 from './assets/tab01img01.mp4'
import tab01img02 from './assets/tab01img02.mp4'
import tab01img03 from './assets/tab01img03.mp4'
import tab01img04 from './assets/tab01img04.mp4'
import tab01img05 from './assets/tab01img05.mp4'
import tab01img06 from './assets/tab01img06.mp4'
import tab01img07 from './assets/tab01img07.mp4'
import tab01img08 from './assets/tab01img08.mp4'
import tab01img09 from './assets/tab01img09.mp4'

import tab02img01 from './assets/tab02img01.mp4'
import tab02img02 from './assets/tab02img02.mp4'
import tab02img03 from './assets/tab02img03.mp4'
import tab02img04_06 from './assets/tab02img04-06.mp4'
import tab02img05 from './assets/tab02img05.mp4'
import tab02img07 from './assets/tab02img07.mp4'
import tab02img08 from './assets/tab02img08.mp4'

import tab03img01 from './assets/tab03img01.mp4'
import tab03img02 from './assets/tab03img02.mp4'
import tab03img03 from './assets/tab03img03.mp4'
import tab03img04 from './assets/tab03img04.mp4'
import tab03img05 from './assets/tab03img05.mp4'

import './Aspect02.css'

class Aspect02 extends React.Component {

  render() {
    return (
      <div className="Chapter04-Aspect02">
        <PageContent nospacing>
          <ContentMenu
          menuOnTop
          activeHasBackground
          tabs={[
            'Anti-Collisionlight of APU',
            'Transponder',
            'Breekbout',
          ]}>

            <ContentMenuTab>
              <div className="has-padding">

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text style={{ marginBottom: '3rem' }}>Zodra je merkt dat het Anti-Collisionlight of APU defect is neem je contact op met je afhandelaar. Deze zorgt ervoor dat er een begeleider jouw kant op komt.</Text>
                    <Text>Ook neem je direct contact op met Apron Control. Je moet de volgende punten melden:</Text>
                    <ul className="no-margin">
                      <li>Positie</li>
                      <li>Bestemming</li>
                      <li>Dat je geen anti-collisionlight meer kunt voeren en daardoor begeleidt wordt door 	een sleeptrekker/voertuig van je eigen maatschappij</li>
                      <li>Callsign van de begeleider</li>
                    </ul>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab01img01} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab01img02} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Bij jou aangekomen neemt de begeleider de procedure met je door en zet vervolgens het amberkleurige zwaailicht aan.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Zowel jij als je de begeleider vragen nu de de sleepbeweging aan bij Apron Control. Zodra Apron Control toestemming heeft gegeven, kan de sleep beginnen of vervolgd worden.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab01img03} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab01img04} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Tijdens het slepen rijdt de begeleider achter het vliegtuig, om het einde van de sleep aan te geven.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Indien een beschikbare baan gekruisd moet worden, stelt Apron Control LVNL op de hoogte van de aanwezigheid, de reden en het callsing van de begeleider. Apron Control geeft jullie de opdracht om over te schakelen naar LVNL voor het aanvragen van de baankruising.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab01img05} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab01img06} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Zowel jij als de begeleider doen afzonderlijk van elkaar de aanvraag voor de baankruising.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Zodra LVNL toestemming geeft en de stopbar gedoofd is, kruisen jullie achter elkaar de baan.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab01img07} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab01img08} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Zodra je de baankruising voltooid hebt geef je dit door aan LVNL en schakel je terug naar Apron Control. Apron Control geeft je zo nodig de opdracht het gesleepte vliegtuig tijdelijk stil te zetten om de begeleider weer aan te laten sluiten. Wanneer de begeleider zich weer achter jou bevindt, geeft Apron Control dit aan jou door en kan de sleepbeweging hervat worden.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Zodra je op je bestemming bent aangekomen meldt je dit bij Apron Control. De begeleider meldt zich vervolgens af bij Apron Control.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab01img09} inline/>
                  </div>
                </div>

              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="has-padding">

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text style={{ marginBottom: '3rem' }}>Zoals je in hoofdstuk 2 geleerd hebt, sta je tijdens het slepen onder active control bij Apron Control. Zij kunnen je door middel van je transponder volgen. Indien blijkt dat je transponder kapot is, heb je begeleiding nodig en neem je contact op met Apron Control.</Text>
                    <Text>Je meldt de volgende punten aan Apron Control</Text>
                    <ul className="no-margin">
                      <li>Positie</li>
                      <li>Bestemming</li>
                      <li>Defecte transponder</li>
                    </ul>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab02img01} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab02img02} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Apron Control geeft je de opdracht de sleep, vrij van banen, stil te zetten. Zij sturen vervolgens een begeleidend voertuig met werkende transponder naar je toe.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Bij jou aangekomen neemt de begeleider de procedure met je door en zet vervolgens het amberkleurige zwaailicht aan.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab02img03} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab02img04_06} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Jij doet tijdens het slepen alle radiocommunicatie. De begeleider luistert enkel op de desbetreffende frequenties uit. Jij vraagt nu dan ook de sleepbeweging aan bij Apron Control. Zodra Apron Control toestemming heeft gegeven, kan de sleep vervolgd worden.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Tijdens het slepen rijdt de begeleider naast de sleeptrekker.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab02img05} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab02img04_06} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Indien het nodig is om een baan te kruisen, doe jij de aanvraag bij LVNL. De begeleider doet dit niet en luistert enkel mee.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Zodra LVNL toestemming geeft en de stopbar gedoofd is, kruisen jij en de begeleider naast elkaar de baan.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab02img07} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab02img08} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Zodra je op je bestemming bent aangekomen meld je dit bij Apron Control. De begeleider meldt zich vervolgens af bij Apron Control.</Text>
                  </div>
                </div>

              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="has-padding">

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Een breekbout is een veiligheidsvoorziening tussen de trekker en het vliegtuig, deze gaat kapot als je bijvoorbeeld een te scherpe bocht neemt.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab03img01} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab03img02} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>Zodra je merkt dat de breekbout gebroken is, zet je de sleep op een veilige positie stil. Je neemt vervolgens contact op met Apron Control én met je afhandelaar.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Apron Control stuurt iemand jouw kant op om de baan te inspecteren op eventuele restanten van de breekbout.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab03img03} inline/>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Image-wrapper">
                    <Video src={tab03img04} inline/>
                  </div>
                  <div className="Text-wrapper">
                    <Text>De afhandelaar zorgt ervoor dat de sleepbeweging voortgezet kan worden door een nieuwe breekbout of een andere vliegtuigtrekker te brengen.</Text>
                  </div>
                </div>

                <div className="has-two-cols">
                  <div className="Text-wrapper">
                    <Text>Als de trekker weer veilig gekoppeld zit aan het vliegtuig kan de sleep voortgezet worden.</Text>
                  </div>
                  <div className="Image-wrapper">
                    <Video src={tab03img05} inline/>
                  </div>
                </div>

              </div>
            </ContentMenuTab>

          </ContentMenu>
        </PageContent>
      </div>
    )
  }
}

export default Aspect02



// WEBPACK FOOTER //
// ./src/content/chapters/04/02/Aspect02.js